import { Button } from "@mantine/core";
import { IconHelpCircle } from "@tabler/icons-react";

type Props = {
  onClick: () => void;
  active?: boolean;
};

export default function HelpButton({ onClick, active = false }: Props) {
  return (
    <Button
      size="compact-md"
      radius="xl"
      variant={active ? "filled" : "light"}
      leftSection={<IconHelpCircle size={17} />}
      aria-pressed={active}
      onClick={onClick}
    >
      راهنما
    </Button>
  );
}
